import React from 'react';
import { Button, Checkbox } from 'antd';

import { SearchOutlined } from '@ant-design/icons';
import { Container, FilterOptions } from './styles';
import { BoxInput } from '../../Orders/components/Filters/styles';

const CheckboxGroup = Checkbox.Group;

const filterCheckboxOptions = [
  {
    label: 'Mostrar na home',
    value: 'is_show_home',
  },
];

export function Filters({
  checkedFilters,
  setCheckedFilters,
  searchTechnicalTeam,
  sortTestimonial,
  isSortLoading,
  searchWord,
  setSearchWord,
  clearSearch,
}) {
  const hangleCheckboxFilter = (list) => {
    setCheckedFilters(list);
  };

  return (
    <Container>
      <BoxInput>
        <input
          id="search"
          type="text"
          name="search"
          placeholder="Nome"
          onChange={(event) => setSearchWord(event.target.value)}
          onKeyDown={(event) => event.key === 'Enter' && searchTechnicalTeam()}
          value={searchWord}
        />
      </BoxInput>

      <FilterOptions>
        <CheckboxGroup
          style={{ marginTop: 15, marginLeft: 15 }}
          options={filterCheckboxOptions}
          value={checkedFilters}
          onChange={hangleCheckboxFilter}
        />
      </FilterOptions>

      <Button
        icon={<SearchOutlined />}
        style={{ marginLeft: 20 }}
        type="primary"
        onClick={searchTechnicalTeam}
      >
        Buscar
      </Button>

      <Button
        loading={isSortLoading}
        style={{ marginLeft: 20 }}
        onClick={sortTestimonial}
      >
        Salvar ordenação
      </Button>

      <Button
        type="link"
        loading={isSortLoading}
        style={{ marginLeft: 20 }}
        onClick={clearSearch}
      >
        Limpar busca
      </Button>
    </Container>
  );
}
